import type { AdminRole } from '@goelectric/shared-types';
import { Navigate, Outlet } from 'react-router-dom';
import { ForbiddenPage } from '@/app/ForbiddenPage';
import { FullPageLoader } from '@/layouts/FullPageLoader';
import { useAuth } from '../context/AuthContext';

/**
 * Guarda de ruta por rol: exige que el usuario autenticado tenga uno de los roles
 * permitidos. Sin permiso muestra una página 403 (el usuario está autenticado; no
 * tiene sentido redirigirlo al login).
 */
export function RequireRole({ roles }: { roles: readonly AdminRole[] }) {
  const { status, user } = useAuth();

  if (status === 'checking') {
    return <FullPageLoader />;
  }
  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace />;
  }
  if (!roles.includes(user.role)) {
    return <ForbiddenPage />;
  }
  return <Outlet />;
}
